import Header from "./components/header";
import Main from "./components/main";

import "./styles/app.css";

export default function App() {
    return (
        <>
            <Header />
            <Main />
        </>
    );
}
